"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotShreddedPickingsCSV = getNotShreddedPickingsCSV;
const papaparse_1 = require("papaparse");
const constants_1 = require("../constants");
function getNotShreddedPickingsCSV(documents) {
    const i18n = constants_1.I18N_RETURNS_HEADINGS;
    return (0, papaparse_1.unparse)(documents.map(({ createdAt, encodedPublicId, scanId }) => {
        return {
            [i18n.customerPublicId]: encodedPublicId,
            [i18n.documentId]: scanId,
            [i18n.dateOfReceival]: createdAt,
        };
    }), { delimiter: ';', quotes: true });
}
//# sourceMappingURL=get-not-shredded-pickings-csv.js.map